export const AVATAR_SIZE = 45;
export const TEST_ID_APP_BAR_AVATAR = 'app-bar-avatar-test-id';
export const TEST_ID_APP_BAR_AVATAR_LINK = 'app-bar-avatar-nav-link-test-id';
export const TEST_ID_APP_BAR_AVATAR_DROPDOWN =
  'app-bar-avatar-dropdown-test-id';

export const GAVITTI_DIRECT_LINK = 'https://us.apa.gaviti.com/auth/login';
